import { defineStore } from 'pinia';
import axios from 'axios';
import { h } from 'vue';

export const useArticlesStore = defineStore('articles', {
	state: () => ({
		articles: [],
        article: {},
        new_article: [],
        loading: false,
	}),

	actions: {
		async fetchArticles(market_id) {
            this.loading = true;
            try {
                const response = await axios.post('vuejs/get_articles',
                {
                    market_id: market_id,
                },
                { withCredentials: true });

                this.articles = response.data;
            } 
            catch (error) {
                console.error('Error fetching articles:', error);
            }
            finally {
                this.loading = false;
            }
		},
        async fetchArticle(kw_id, market_id) {
            this.loading = true;
            this.article = {};
            try {
                // Use legacy endpoint for old text editor version (returns flat structure)
                const response = await axios.post('vuejs/get_article_legacy',
                {
                    kw_id: kw_id,
                    market_id: market_id,
                },
                { withCredentials: true });

                // Legacy endpoint returns flat article structure directly
                this.article = response.data || {};
            } 
            catch (error) {
                console.error('Error fetching article:', error);
            }
            finally {
                this.loading = false;
            }
        },
        async createArticle(market_id, kw_id, url, title, target_date, redactor_id) {
            try {
                const response = await axios.post('vuejs/create_article',
                {
                    market_id: market_id,
                    kw_id: kw_id,
                    url: url,
                    title: title,
                    target_date: target_date,
                    redactor: redactor_id, // Add the redactor ID to the request
                },
                { withCredentials: true });

                if (Array.isArray(this.new_article)) {
                    this.new_article.push(response.data);
                } else {
                    this.new_article = [response.data];
                }
                
                this.article = response.data;
                
                if (this.articles && Array.isArray(this.articles)) {
                    this.articles.push(response.data);
                }
                
                return response.data;
            } 
            catch (error) {
                console.error('Error creating article:', error);
                throw error;
            }
        },
        async deleteArticle(article_id) {
            try {
                const response = await axios.post('vuejs/delete_article',
                {
                    article_id: article_id,
                },
                { withCredentials: true });

                this.articles = this.articles.filter(article => article.id !== article_id);
            } 
            catch (error) {
                console.error('Error deleting article:', error);
            }
        },
	},
});
